import { render, staticRenderFns } from "./ProductPerformance.vue?vue&type=template&id=15966f89&scoped=true"
import script from "./ProductPerformance.vue?vue&type=script&lang=js"
export * from "./ProductPerformance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15966f89",
  null
  
)

export default component.exports